const digest = '020db1eb79c46b082e3c6aaff97efef4bf3b5cdceb90420f543397a352a2160d';
const css = `._inavLite_1c3rr_1{background:#fff;left:0;position:fixed;top:0;z-index:99}._inavHeight_1c3rr_9{height:3.9rem}._inavExitButton_1c3rr_13{border:none!important}._inavExitButton_1c3rr_13,._inavExitButton_1c3rr_13:hover{background-color:transparent!important}._inavExitButton_1c3rr_13:active,._inavExitButton_1c3rr_13:focus{border:none!important;outline:none!important}._showUnderLineText_1c3rr_27{text-decoration:underline!important}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'inavLite': '_inavLite_1c3rr_1', 'inavHeight': '_inavHeight_1c3rr_9', 'inavExitButton': '_inavExitButton_1c3rr_13', 'showUnderLineText': '_showUnderLineText_1c3rr_27' };
export const inavLite = '_inavLite_1c3rr_1';
export const inavHeight = '_inavHeight_1c3rr_9';
export const inavExitButton = '_inavExitButton_1c3rr_13';
export const showUnderLineText = '_showUnderLineText_1c3rr_27';
export { css, digest };